import { useState } from 'react'
import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { ScoopText, ScoopRow, ScoopColumn } from '../../../../../../ui'
import styles from './DataLimitationsSection.module.scss'

export const DataLimitationsSection = ({ dataLimitations }) => {
    const [dataLimitationsExpanded, setDataLimitationsExpanded] = useState(true)

    if (!dataLimitations || dataLimitations.length === 0) return null

    return (
        <ScoopColumn className={styles.container}>
            <ScoopRow align="center">
                <ScoopText className={styles.title}>
                    Data Limitations ({dataLimitations.length})
                </ScoopText>
                <button
                    onClick={() => setDataLimitationsExpanded(!dataLimitationsExpanded)}
                    className={styles.expandButton}
                    aria-label="Toggle data limitations"
                >
                    {dataLimitationsExpanded ? (
                        <CaretUpIcon size={16} />
                    ) : (
                        <CaretDownIcon size={16} />
                    )}
                </button>
            </ScoopRow>
            <div
                className={`${styles.collapseContainer} ${dataLimitationsExpanded ? styles.expanded : styles.collapsed}`}
            >
                <ScoopColumn className={styles.content}>
                    {dataLimitations.map((limitation, i) => (
                        <ScoopText key={i} className={styles.limitationItem}>
                            • {limitation}
                        </ScoopText>
                    ))}
                </ScoopColumn>
            </div>
        </ScoopColumn>
    )
}
